//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'STEMI_ECG',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '',
      },
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = 1.196 * form.item3 + 0.059 * (form.item1 * 1000) - 0.326 * form.item2
        if (res >= 23.4) {
          self.text = 'STEMI'
        } else {
          self.text = '早期复极化'
        }
        self.hasScore = true
        return String(res.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/STEMI_ECG.vue